import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    elementID: PropTypes.string,
    onloadCallback: PropTypes.func,
    verifyCallback: PropTypes.func,
    expiredCallback: PropTypes.func,
    recaptchaReadyCallback: PropTypes.func,
    sitekey: PropTypes.string,
    theme: PropTypes.string,
    type: PropTypes.string,
    size: PropTypes.string,
    tabindex: PropTypes.string,
};

const defaultProps = {
    elementID: 'g-recaptcha',
    onloadCallback: undefined,
    verifyCallback: undefined,
    expiredCallback: undefined,
    recaptchaReadyCallback: undefined,
    theme: 'light',
    type: 'image',
    size: 'normal',
    tabindex: '0',
};

let readyCheck;

/**
 * Utilize Google ReCAPTCHA v3
 * Implications:
 * There is no visible rendered ReCAPTCHA
 * Google observes users behavior for a page and determines a score
 * that represents likeliness of being a bot or a human (0.0 - 1.0)
 *
 * Originally (Indra)
 * This is copied from https://raw.githubusercontent.com/appleboy/react-recaptcha/master/src/index.js. However,
 * I need the reset to reset based on widget ID. That's why it's copied here with slight modification.
 */
class Recaptcha extends Component {

    constructor(props) {
        super(props);
        this._readyGrecaptcha = this._readyGrecaptcha.bind(this);
        this.execute = this.execute.bind(this);
        this.recaptchaReadyCallback = props.recaptchaReadyCallback;
        this.isRecaptchaReady = this.isRecaptchaReady.bind(this);
        window.unoCommonJsRecaptchaLoadCallback=this._readyGrecaptcha;
    }

    componentDidMount() {
        const {sitekey} = this.props;

        try {
            // create google recaptcha load script
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?onload=unoCommonJsRecaptchaLoadCallback&render=" + sitekey;
            script.async = true;
            //script.defer = true;
            document.body.appendChild(script);
        } catch(e){
            console.log("Unable to load recaptcha script");
            console.log(e);
        }
    }

    isRecaptchaReady(){
        const {recaptchaReady} = this.getState();
        return recaptchaReady;
    }

    execute(action='general'){
        const {sitekey, verifyCallback} = this.props;
        if (this.isRecaptchaReady()) {
            grecaptcha.ready(async () => {
                try {
                    grecaptcha
                        .execute(sitekey, {action: action})
                        .then(function(token) {
                            verifyCallback(token);
                        });
                } catch (error) {    // Added so that *some* error is displayed to the User
                    // Should never happen - only if API misconfiguration - invalid sitekey
                    console.log(error);
                    verifyCallback('*');
                }
            });
        }
    }

    getState(){
        return this.state ? this.state : {};
    }

    /**
     * Invoked by Google onload callback
     */
    _readyGrecaptcha() {
        try {
            this.props.onloadCallback();    // for prevention of Jcaptcha display
            this.setState({
                ...this.state,
                recaptchaReady: true
            });

        } catch(err){
            console.log("Error occurred while rendering re-captcha. Displaying regular captcha instead.");
            console.log(err);
        }
    }

    render() {  // ideally - nothing to render here, no CAPTCHA challenge gets displayed
        return (
            <div id={this.props.elementID}></div>
        );
    }
}

Recaptcha.propTypes = propTypes;
Recaptcha.defaultProps = defaultProps;
export default Recaptcha;